import React, { useState, useEffect } from "react";
import { Button, DialogContainer, TextField } from "react-md";
import "../styles/availabilityCalendarStyle.css";
import {
  KeyboardDatePicker,
  MuiPickersUtilsProvider,
  TimePicker,
} from "@material-ui/pickers";
import MomentUtils from "@date-io/moment";
import FontIcon from "react-md/lib/FontIcons";
import { Checkbox } from "@material-ui/core";
import EventService from "../../../../../service/event/EventService";
import moment from "moment";

const CalendarAddOns = ({
  heading,
  addOnDialogMode,
  closeCalendarAddOns,
  dayData,
  availability,
  setAvailability,
  type,
  addOnLeave,
  leaveDatesArr,
  availabilityDatesArr,
}) => {
  const [dateFrom, setDateFrom] = useState(null);
  const [dateTo, setDateTo] = useState(null);
  const [applyForFullDay, setApplyForFullDay] = useState(false);
  const [slots, setSlots] = useState([]);

  useEffect(() => {
    if (addOnDialogMode === 1) {
      setDateFrom(null);
      setDateTo(null);
      setApplyForFullDay(false);
      setSlots([{ start: null, end: null, comment: "" }]);
    } else if (addOnDialogMode === 3 || addOnDialogMode === 2) {
      const day = moment(dayData.date, "YYYY-MM-DD");
      setDateFrom(day);
      setDateTo(day);
      if (
        dayData.slots.length === 1 &&
        dayData.slots[0].start === "00:00" &&
        dayData.slots[0].end === "23:59"
      ) {
        setApplyForFullDay(true);
        setSlots([
          {
            start: moment("00:00", "HH:mm"),
            end: moment("23:59", "HH:mm"),
            comment: dayData.slots[0].comment,
          },
        ]);
      } else {
        setApplyForFullDay(false);
        const sl = dayData.slots.map((s) => ({
          start: moment(s.start, "HH:mm"),
          end: moment(s.end, "HH:mm"),
          comment: s.comment,
        }));
        setSlots(sl);
      }
    }
  }, []);

  const exitDialog = () => {
    setDateFrom(null);
    setDateTo(null);
    setApplyForFullDay(false);
    setSlots([]);
    closeCalendarAddOns();
  };

  const isSlotNotFilled = () => slots.some((slot) => !slot.start || !slot.end);

  const hasInvalidTimeOrder = () =>
    slots.some(
      (slot) =>
        slot.start &&
        slot.end &&
        moment.duration(slot.end.diff(slot.start)).asMinutes() < 1
    );

  const hasOverlappingSlots = () => {
    const sorted = [...slots]
      .filter((s) => s.start && s.end)
      .sort((a, b) => a.start.diff(b.start));
    for (let i = 0; i < sorted.length - 1; i++) {
      if (sorted[i].end.isAfter(sorted[i + 1].start)) {
        return true;
      }
    }
    return false;
  };

  const handleSave = () => {
    if (!dateFrom) {
      EventService.emit("showError", { message: "Please select start date" });
      return;
    }
    if (!dateTo) {
      EventService.emit("showError", { message: "Please select end date" });
      return;
    }
    if (isSlotNotFilled()) {
      EventService.emit("showError", {
        message: "Please fill all slot times",
      });
      return;
    }
    if (hasInvalidTimeOrder()) {
      EventService.emit("showError", {
        message: "Each slot's end time must be after its start time",
      });
      return;
    }
    if (hasOverlappingSlots()) {
      EventService.emit("showError", {
        message: "Time slots cannot overlap",
      });
      return;
    }

    const start = moment(dateFrom.format("YYYY-MM-DD"));
    const end = moment(dateTo.format("YYYY-MM-DD"));
    const diffDays = end.diff(start, "days") + 1;

    const sortedFormattedSlots = [...slots]
      .sort((a, b) => a.start.diff(b.start))
      .map((slot) => ({
        start: slot.start.format("HH:mm"),
        end: slot.end.format("HH:mm"),
        comment: slot.comment,
      }));

    let schedule = [];
    for (let i = 0; i < diffDays; i++) {
      schedule.push({
        date: start.clone().add(i, "days").format("YYYY-MM-DD"),
        slots: sortedFormattedSlots,
      });
    }

    // type 1 = unavailability and type 2 = availability
    // addOnDialogMode 1 = add button and addOnDialogMode 3 = edit button clicked

    if (type === 1 && addOnDialogMode === 1) {
      setAvailability({
        ...availability,
        unavailableTime: [...availability.unavailableTime, ...schedule].sort(
          (a, b) => moment(a.date).diff(moment(b.date))
        ),
      });
    } else if (type === 1 && addOnDialogMode === 3) {
      const newUnavailable = availability.unavailableTime.filter(
        (e) => e.date !== addOnLeave
      );
      setAvailability({
        ...availability,
        unavailableTime: [...newUnavailable, ...schedule].sort((a, b) =>
          moment(a.date).diff(moment(b.date))
        ),
      });
    } else if (type === 2 && addOnDialogMode === 1) {
      setAvailability({
        ...availability,
        availableTime: [...availability.availableTime, ...schedule].sort(
          (a, b) => moment(a.date).diff(moment(b.date))
        ),
      });
    } else if (type === 2 && addOnDialogMode === 3) {
      const newAvailable = availability.availableTime.filter(
        (e) => e.date !== addOnLeave
      );
      setAvailability({
        ...availability,
        availableTime: [...newAvailable, ...schedule].sort((a, b) =>
          moment(a.date).diff(moment(b.date))
        ),
      });
    }

    exitDialog();
  };

  return (
    <div>
      <DialogContainer
        id="calendar-add-on"
        visible
        onHide={exitDialog}
        height="auto"
        width="920px"
        focusOnMount={false}
        className="calendar-add-on-container"
        style={{ textAlign: "left" }}
      >
        <div style={{ display: "flex", justifyContent: "space-between" }}>
          <h4>{heading}</h4>
          <div>
            {addOnDialogMode !== 2 && (
              <Button raised className="btn-enabled" onClick={handleSave}>
                {addOnDialogMode === 3 ? "Update" : "Save"}
              </Button>
            )}
            <Button
              raised
              className="btn-disabled"
              style={{ marginLeft: "15px" }}
              onClick={exitDialog}
            >
              Cancel
            </Button>
          </div>
        </div>

        <div style={{ display: "flex", marginTop: "10px" }}>
          <div className="calendar-field-container">
            <div className="calendar-label-text">Date</div>
            <MuiPickersUtilsProvider utils={MomentUtils}>
              <KeyboardDatePicker
                value={dateFrom}
                onChange={(date) => {
                  setDateFrom(date);
                  if (addOnDialogMode === 3) setDateTo(date);
                }}
                autoOk
                format="DD MMM YYYY"
                placeholder="Choose a date"
                keyboardIcon={<FontIcon>calendar_month</FontIcon>}
                variant="inline"
                minDate={addOnDialogMode == 2 ? undefined : moment()}
                maxDate={
                  addOnDialogMode == 3 ? undefined : dateTo ? dateTo : undefined
                }
                disabled={addOnDialogMode == 2}
                shouldDisableDate={(date) =>
                  type == 1
                    ? leaveDatesArr.includes(moment(date).format("YYYY-MM-DD"))
                    : type == 2
                    ? availabilityDatesArr.includes(
                        moment(date).format("YYYY-MM-DD")
                      )
                    : false
                }
              />
            </MuiPickersUtilsProvider>
          </div>

          <div className="separate-fields-to">To</div>

          <div className="calendar-field-container">
            <div className="calendar-label-text">Date</div>
            <MuiPickersUtilsProvider utils={MomentUtils}>
              <KeyboardDatePicker
                value={dateTo}
                onChange={(date) => setDateTo(date)}
                autoOk
                format="DD MMM YYYY"
                placeholder="Choose a date"
                keyboardIcon={<FontIcon>calendar_month</FontIcon>}
                variant="inline"
                minDate={
                  addOnDialogMode == 2
                    ? undefined
                    : dateFrom
                    ? dateFrom
                    : moment()
                }
                maxDate={
                  dateFrom
                    ? type == 1
                      ? leaveDatesArr
                          .filter(
                            (date) =>
                              date > moment(dateFrom).format("YYYY-MM-DD")
                          ) // Get dates greater than dateFrom
                          .sort()[0] || undefined
                      : type == 2
                      ? availabilityDatesArr
                          .filter(
                            (date) =>
                              date > moment(dateFrom).format("YYYY-MM-DD")
                          ) // Get dates greater than dateFrom
                          .sort()[0] || undefined
                      : undefined
                    : undefined
                }
                disabled={
                  addOnDialogMode == 3 ||
                  addOnDialogMode == 2 ||
                  (addOnDialogMode == 1 && !dateFrom)
                }
                shouldDisableDate={(date) =>
                  type == 1
                    ? leaveDatesArr.includes(moment(date).format("YYYY-MM-DD"))
                    : type == 2
                    ? availabilityDatesArr.includes(
                        moment(date).format("YYYY-MM-DD")
                      )
                    : false
                }
              />
            </MuiPickersUtilsProvider>
          </div>
        </div>

        <div
          style={{ display: "flex", alignItems: "center", margin: "10px 0" }}
        >
          <Checkbox
            checked={applyForFullDay}
            disabled={addOnDialogMode === 2}
            onChange={() => {
              if (applyForFullDay) {
                setSlots([{ start: null, end: null, comment: "" }]);
              } else {
                setSlots([
                  {
                    start: moment("00:00", "HH:mm"),
                    end: moment("23:59", "HH:mm"),
                    comment: "",
                  },
                ]);
              }
              setApplyForFullDay(!applyForFullDay);
            }}
          />
          <div>Apply for full day</div>
        </div>

        <MuiPickersUtilsProvider utils={MomentUtils}>
          {slots.map((slot, index) => (
            <div className="time-addon" key={index}>
              <div className="time-container">
                <div className="time-text">Start time</div>
                <TimePicker
                  value={slot.start}
                  onChange={(value) => {
                    const updated = [...slots];
                    updated[index].start = value;
                    setSlots(updated);
                  }}
                  disabled={applyForFullDay || addOnDialogMode === 2}
                />
              </div>
              <div className="time-container">
                <div className="time-text">End time</div>
                <TimePicker
                  value={slot.end}
                  onChange={(value) => {
                    const updated = [...slots];
                    updated[index].end = value;
                    setSlots(updated);
                  }}
                  disabled={
                    applyForFullDay || addOnDialogMode === 2 || !slot.start
                  }
                  minTime={slot.start}
                />
              </div>
              <div className="calendar-field-container-comment">
                <div className="calendar-label-text">Remarks</div>
                <TextField
                  value={slot.comment}
                  onChange={(value) => {
                    const updated = [...slots];
                    updated[index].comment = value;
                    setSlots(updated);
                  }}
                  disabled={addOnDialogMode === 2}
                />
              </div>
              {addOnDialogMode !== 2 && index > 0 && (
                <div
                  className="remove-slot"
                  onClick={() => {
                    setSlots(slots.filter((_, i) => i !== index));
                  }}
                >
                  <FontIcon>close</FontIcon>
                </div>
              )}
              {!applyForFullDay &&
                !isSlotNotFilled() &&
                index === slots.length - 1 &&
                addOnDialogMode !== 2 && (
                  <div
                    className="add-more"
                    onClick={() =>
                      setSlots([
                        ...slots,
                        { start: null, end: null, comment: "" },
                      ])
                    }
                  >
                    + Add more slots
                  </div>
                )}
            </div>
          ))}
        </MuiPickersUtilsProvider>
      </DialogContainer>
    </div>
  );
};

export default CalendarAddOns;
